import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Partners = () => {
  const { t } = useTranslation();
  
  const partners = [
    { id: 1, name: 'Microsoft Data AI', logo: '/assets/pic/microsoft_data_ai_spec.jpg' },
    { id: 2, name: 'NVIDIA Inception', logo: '/assets/pic/nvidia-inception-program-badge-rgb-for-screen.jpg' },
    { id: 3, name: 'Center Q', logo: '/assets/pic/centerqcolor.jpg' },
    { id: 4, name: 'PT Logo', logo: '/assets/pic/pt-logo-b-2.png' },
    { id: 5, name: 'Group 43', logo: '/assets/pic/group-43.png' },
    { id: 6, name: 'Group', logo: '/assets/pic/group.png' },
    { id: 7, name: 'Logo EN', logo: '/assets/pic/logo_en-2-e1655656870347.png' },
    { id: 8, name: 'OG', logo: '/assets/pic/og-4c10bae940c8c3309fdc642f2d0776216c76d399bc0b935c6ed3fa019bfc4d98-e1655891755572-300x108-1.png' },
    { id: 9, name: 'Photo 1', logo: '/assets/pic/photo_2024-03-13_11-21-13.jpg' },
    { id: 10, name: 'Photo 2', logo: '/assets/pic/photo_2024-03-25_15-34-31.jpg' },
    { id: 11, name: 'Photo 3', logo: '/assets/pic/photo_2024-04-04_07-49-12.jpg' },
    { id: 12, name: 'Photo 4', logo: '/assets/pic/photo_2024-04-04_14-20-20-768x768.jpg' },
    { id: 13, name: 'Image 6142', logo: '/assets/pic/img_6142.png' },
    { id: 14, name: 'Google Cloud Support', logo: '/assets/pic/do-all-kind-of-google-cloud-support.jpg' },
    { id: 15, name: 'Logo', logo: '/assets/pic/6353c7b7ebc462e51df5c89fc0182839-300x300.jpg' }
  ];

  // Дублюємо партнерів для безперервної анімації
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="partners-section">
      <motion.h2 
        className="section-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        {t('partners.title')}
      </motion.h2>
      
      <motion.div 
        className="section-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
      >
        <p>{t('partners.description')}</p>
      </motion.div>
      
      <div className="partners-container">
        <div className="partners-slider">
          {duplicatedPartners.map((partner, index) => (
            <motion.div 
              key={`${partner.id}-${index}`}
              className="partner-item"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.05 % 1 }}
            >
              <img 
                src={partner.logo} 
                alt={partner.name} 
                title={partner.name}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners; 